<template>
  <li :class="{ 'is-selected' : id == selectedOrganisationalUnit.id }">
    <div class="test-item columns">
      <div @click="toggle" v-bind:class="{'tree-branch-icon': !isFolder}" class="column" style="max-width: 10px; margin-right: 5px;">
        <b-icon v-if="isFolder && !open" pack="fa" icon="angle-right" size="is-small" :title="$gettext('tree.open')"></b-icon>
        <b-icon v-if="isFolder && open" pack="fa" icon="angle-down" size="is-small" :title="$gettext('tree.collapse')"></b-icon>
      </div>
      <div
      class="ou-item column"
      >
      <!-- <b-icon v-if="!isFolder" pack="fa" icon="circle-thin" size="is-small"></b-icon> -->
      <!-- <span v-if="!isFolder" style="font-size: 0.7em;">∟</span> -->

        <div class="ou-item-title" @click="select(model)">
          <router-link
            style="color: inherit; text-decoration: none;"
            tag="a"
            :to="{
              name: 'public',
              params: {
                type: 'ou',
                id: model.id,
                resourceType: activeResourceType
              }
            }"
          >
            {{ model.name }} 
            <div v-if="getOrgaDuration(model)" class="has-text-grey">
              {{ getOrgaDuration(model) }}
            </div> 
          </router-link>  
        </div>
      </div>
    </div>
    <ul v-show="open" v-if="isFolder">
      <li v-if="loading" style="margin-left: 30px;"><translate>tree.loading</translate>...</li>
      <fob-tree-item
        v-on:open="handleOpenEvent"
        class="item"
        style="margin-left: 20px;"
        v-for="(childData, index) in childData.children"
        :parent="newParent"
        :isOpen="childData.id == openBranch"
        :key="index"
        :model="childData">
      </fob-tree-item>
    </ul>
  </li>
</template>

<script>
  import { graphql } from '@/axios'
  import { fetchOuQuery } from '@/graphql'
  import { mapActions, mapGetters } from 'vuex'
  import PublicViewHelper from '@/components/mixins/PublicViewHelper'
  import OrgaDurationHelper from '@/components/mixins/OrgaDurationHelper'

  export default ('treeItem', {
    name: 'fob-tree-item',
    mixins: [PublicViewHelper, OrgaDurationHelper],
    props: ['root', 'model', 'parent', 'isOpen'],
    data: function () {
      return {
        childData: {},
        id: this.model.id,
        open: false,
        openBranch: -1,
        loading: false,
        isSelected: false
      }
    },
    computed: {
      ...mapGetters({
        selectedOrganisationalUnit: 'tree/selected'
      }),
      isFolder: function () {
        return this.model.children &&
          this.model.children.length
      },
      newParent () {
        let path = []
        if (Array.isArray(this.parent)) {
          path = this.parent.concat([this.id])
        } else {
          path = [this.id]
        }
        return path
      }
    },
    methods: {
      ...mapActions({
        'saveBranchData': 'tree/saveBranchData',
        'saveOpenBranch': 'tree/saveOpenBranch',
        'removeOpenBranch': 'tree/removeOpenBranch',
        'selectBranch': 'tree/selectBranch'
      }),
      loadAsyncData () {
        this.loading = true
        graphql(fetchOuQuery(this.id))
        .then(response => {
          this.childData = response.data.data.organisationalUnit
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
      },
      toggle: function () {
        // only collapse tree if children are available
        if (this.isFolder) {
          // dont refetch
          if (!this.childData.name) {
            // query via axios
            this.loading = true
            this.loadAsyncData()
          }
          this.open = !this.open // open branch
          if (this.open) {
            this.saveOpenBranch(this.id)
          } else {
            this.removeOpenBranch(this.id)
          }
          this.saveBranchData(this)
        }
      },
      openParent () {
        if (!this.open) {
          this.toggle()
        }
      },
      select (model) {
        this.openParent()
        this.selectBranch(model)
      },
      handleOpenEvent (eventData) {
        this.openBranch = eventData
        this.saveBranchData(this)
      }
    },
    mounted () {
      // if root element fetch query and open branches
      if (this.root) {
        this.open = true
      }
      // read store data
      let treeItemData = this.$store.state.tree.branch[this.id]
      if (treeItemData) {
        this.childData = treeItemData.childData
        this.id = treeItemData.id
        this.open = this.root || this.isOpen || this.open || false
        this.openBranch = treeItemData.openBranch
      }
    },
    watch: {
      isOpen () {
        this.open = this.isOpen
      }
    }
  })
</script>

<style lang="scss">

  .test-item {
    line-height: 1.4em;
    margin: 0 !important;
    padding: 0 !important;
    .columns {
      margin: 0 !important;
      padding: 0 !important;
    }
    .column {
      margin: 0;
      padding: 0.3em 0.5em 0.3em 0.5em;
    }
  }

  .tree-branch-icon:before {
    // content: '∟';
    // margin: 0 0.2em;
    content: '·';
    position: relative;
    left: 0.35em;
    top: -0.1em;
  }

  .ou-item {
    vertical-align: middle;
    display: inline;

    .ou-item-title {
      margin: 0 5px 0 0px;
    }

    .set-ou-id {
      display: none;
      font-size: 0.6rem;
      margin-left: 5px;
    }
  }

  .ou-item:hover {
    .set-ou-id {
      display: inline-block;
    }
  }

  .is-selected {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/tree/TreeItem.vue